import React from "react"
import { EstateTitleStyled } from "./estatesStyle"
const EstateTitle = ({ mainTitle, subTitleBold, subtitle }) => {
  return (
    <EstateTitleStyled>
      {mainTitle && <h1>{mainTitle}</h1>}
      {subTitleBold && <p>{subTitleBold}</p>}
      {subtitle && <p dangerouslySetInnerHTML={{__html: subtitle}} />}
    </EstateTitleStyled>
  )
}

export default EstateTitle
